module.exports = __webpack_public_path__ + "static/media/pen-fancy.95c06db1.svg";